import * as React from "react";
export const BlogicGameIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={107.5} height={155.875} viewBox="0 0 107.5 155.875" {...props}>
      <g transform="translate(-32.25 -5.375)">
        <path
          d="M40.313,8.063h91.375a5.375,5.375,0,0,1,5.375,5.375v129a16.125,16.125,0,0,1-16.125,16.125H40.313a5.375,5.375,0,0,1-5.375-5.375V13.438A5.375,5.375,0,0,1,40.313,8.063Z"
          fill="#ffeb9b"
        />
        <path
          d="M120.938,24.188H53.751a2.687,2.687,0,0,0-2.687,2.688v53.75a2.687,2.687,0,0,0,2.688,2.688h56.438a10.75,10.75,0,0,0,10.75-10.75Z"
          fill="#bbdef9"
        />
        <path
          d="M120.938,44.048,81.674,83.313h28.514a10.75,10.75,0,0,0,10.75-10.75Zm0-19.861h-8.062L53.751,83.313H69.876L120.938,32.25Zm-24.188,0L51.063,69.875v8.063l53.75-53.75Z"
          fill="#def0ff"
        />
        <path
          d="M103.254,40.313l2.284,4.193,4.219,2.311L105.538,49.1l-2.284,4.219L100.943,49.1,96.75,46.816l4.192-2.311Z"
          fill="#fff"
        />
        <path
          d="M72.563,104.813V96.751a2.687,2.687,0,0,0-2.687-2.687H64.5a2.687,2.687,0,0,0-2.687,2.688v8.063H53.75a2.687,2.687,0,0,0-2.687,2.688v5.375a2.687,2.687,0,0,0,2.688,2.688h8.063v8.063a2.687,2.687,0,0,0,2.688,2.688h5.375a2.687,2.687,0,0,0,2.688-2.687v-8.062h8.063a2.687,2.687,0,0,0,2.688-2.687V107.5a2.687,2.687,0,0,0-2.687-2.687Z"
          fill="#ed7899"
        />
        <path
          d="M114.219,94.063a9.406,9.406,0,1,0,9.406,9.406A9.406,9.406,0,0,0,114.219,94.063Z"
          fill="#85cbf8"
        />
        <path
          d="M99.438,118.25a5.375,5.375,0,1,0,5.375,5.375A5.375,5.375,0,0,0,99.438,118.25Z"
          fill="#97e0bb"
        />
        <path
          d="M45.688,139.75h91.375a18.812,18.812,0,0,1-18.812,18.813H34.938V150.5A10.75,10.75,0,0,1,45.688,139.75Z"
          fill="#f6d397"
        />
        <path
          d="M51.063,86h59.125a13.437,13.437,0,0,0,13.438-13.437V24.188a2.687,2.687,0,0,0-2.687-2.687H51.063a2.687,2.687,0,0,0-2.687,2.688V83.313A2.687,2.687,0,0,0,51.063,86ZM53.75,26.875h64.5V72.563a8.062,8.062,0,0,1-8.062,8.063H53.75Zm0,91.375h5.375v5.375A5.375,5.375,0,0,0,64.5,129h5.375a5.375,5.375,0,0,0,5.375-5.375V118.25h5.375A5.375,5.375,0,0,0,86,112.875V107.5a5.375,5.375,0,0,0-5.375-5.375H75.25V96.75a5.375,5.375,0,0,0-5.375-5.375H64.5a5.375,5.375,0,0,0-5.375,5.375v5.375H53.75a5.375,5.375,0,0,0-5.375,5.375v5.375A5.375,5.375,0,0,0,53.75,118.25Zm0-10.75h8.063a2.687,2.687,0,0,0,2.688-2.687V96.75h5.375v8.063a2.687,2.687,0,0,0,2.688,2.688h8.063v5.375H72.563a2.687,2.687,0,0,0-2.687,2.688v8.063H64.5v-8.062a2.687,2.687,0,0,0-2.687-2.687H53.75Z"
          fill="#8d6c9f"
        />
        <path
          d="M131.688,5.375H40.313a8.062,8.062,0,0,0-8.062,8.063v139.75a8.062,8.062,0,0,0,8.063,8.063h80.625a18.812,18.812,0,0,0,18.812-18.812v-129A8.062,8.062,0,0,0,131.688,5.375Zm2.687,137.063a13.438,13.438,0,0,1-13.437,13.438H40.313a2.687,2.687,0,0,1-2.687-2.687V13.438a2.687,2.687,0,0,1,2.688-2.687h91.375a2.687,2.687,0,0,1,2.688,2.688Z"
          fill="#8d6c9f"
        />
        <path
          d="M64.5,48.375a2.687,2.687,0,0,0-2.687,2.688v5.375a2.688,2.688,0,0,0,5.375,0V51.063A2.687,2.687,0,0,0,64.5,48.375Zm13.438,0a2.687,2.687,0,0,0-2.687,2.688v5.375a2.688,2.688,0,0,0,5.375,0V51.063A2.687,2.687,0,0,0,77.938,48.375Zm13.438,0a2.687,2.687,0,0,0-2.687,2.688v5.375a2.688,2.688,0,0,0,5.375,0V51.063A2.687,2.687,0,0,0,91.375,48.375Zm13.438,0a2.687,2.687,0,0,0-2.687,2.688v5.375a2.688,2.688,0,1,0,5.375,0V51.063A2.687,2.687,0,0,0,104.813,48.375Zm9.406,43a12.094,12.094,0,1,0,12.094,12.094,12.094,12.094,0,0,0-12.094-12.094Zm0,18.813a6.719,6.719,0,1,1,6.719-6.719A6.719,6.719,0,0,1,114.219,110.188Zm-14.782,5.375a8.062,8.062,0,1,0,8.063,8.063A8.062,8.062,0,0,0,99.438,115.563Zm0,10.75a2.688,2.688,0,1,1,2.688-2.687A2.687,2.687,0,0,1,99.438,126.313Zm2.688,18.812H45.688a2.688,2.688,0,0,0,0,5.375h56.438a2.688,2.688,0,0,0,0-5.375Zm21.5,0h-10.75a2.688,2.688,0,0,0,0,5.375h10.75a2.688,2.688,0,0,0,0-5.375Z"
          fill="#8d6c9f"
        />
        <path
          d="M77,64.5l1.559,2.876,2.876,1.559-2.876,1.559L77,73.369l-1.559-2.876-2.876-1.559,2.876-1.559Zm-.4-34.937,3.332,6.074L86,38.969,79.926,42.3l-3.332,6.074L73.261,42.3l-6.074-3.333,6.074-3.333Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
